import { render, staticRenderFns } from "./AssignLabelsModal.vue?vue&type=template&id=cd512594&scoped=true"
import script from "./AssignLabelsModal.vue?vue&type=script&lang=ts"
export * from "./AssignLabelsModal.vue?vue&type=script&lang=ts"
import style0 from "./AssignLabelsModal.vue?vue&type=style&index=0&id=cd512594&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd512594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd512594')) {
      api.createRecord('cd512594', component.options)
    } else {
      api.reload('cd512594', component.options)
    }
    module.hot.accept("./AssignLabelsModal.vue?vue&type=template&id=cd512594&scoped=true", function () {
      api.rerender('cd512594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/AssignLabelsModal.vue"
export default component.exports